import baseApi from './baseApi'

export const sessionWiseApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSessionWiseData: builder.query({
      query: ({ userId, isGroup }) => ({
        method: 'POST',
        url: '/subject_wise',
        body: { user_id: userId, isGroup },
      }),
      providesTags: ['brain_report'],
    }),
    getCummulative: builder.query({
      query: ({ userId, isGroup, ...filters }) => ({
        method: 'POST',
        url: '/profile_screen_aggregate',
        body: { isGroup, user_id: userId, ...filters },
      }),
      transformResponse: (data) => {
        return {
          Learning_Style: data.user.Learning_Style,
          Brain_Strength: data.user.Brain_Strength,
          Emotional_Analysis: data.user.Emotional_Analysis,
          Performance_Metric: data.user.Performance_Metric,
        }
      },
      providesTags: ['brain_report'],
    }),
  }),
  overrideExisting: false,
})

// auto-generated based on the defined endpoints
export const { useGetSessionWiseDataQuery, useGetCummulativeQuery } = sessionWiseApi
